import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getStats = () => axios.get(`${API}/stats`).then((r) => r.data);

export const createApplication = (payload) =>
  axios.post(`${API}/applications`, payload).then((r) => r.data);

export const verifyPayment = (payload) =>
  axios.post(`${API}/applications/verify`, payload).then((r) => r.data);

export const getRecentBookings = () =>
  axios.get(`${API}/recent-bookings`).then((r) => r.data);

export const trackOrder = (query) =>
  axios.post(`${API}/orders/track`, { query }).then((r) => r.data);
